module.exports = __webpack_public_path__ + "img/ikon_manet.a6370830.svg";